import {
  SET_LOADING_DATA,
  GET_LIST_ALL_REQUEST,
  GET_LIST_ALL_SUCCESS,
  SET_LOADING_SELECTS,
  SET_ORDER,
  SET_ORDERBY,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SHARE_CSV,
  GET_LIST_SELECTS_REQUEST,
  GET_LIST_SELECTS_SUCCESS
} from './daily-route-report-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const getAllDailyReportReportsRequest = payload => {
  return {
    type: GET_LIST_ALL_REQUEST,
    payload
  };
};

export const getAllDailyReportReportsSuccess = payload => {
  return {
    type: GET_LIST_ALL_SUCCESS,
    payload
  };
};

export const getListSelectsRequest = ({ queryText, skip }: { queryText?: string; skip?: number }) => {
  return {
    type: GET_LIST_SELECTS_REQUEST,
    queryText,
    skip
  };
};

export const getListSelectsSuccess = payload => {
  return {
    type: GET_LIST_SELECTS_SUCCESS,
    payload
  };
};

export const shareCSV = (payload: any, exportType: string) => {
  return {
    type: SHARE_CSV,
    payload,
    exportType
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const shareCsv = (payload?: { queryString: string; date: Date[] }) => {
  return {
    type: SHARE_CSV,
    payload
  };
};
